import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';



import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";

import "intersection-observer";
import Sticky from "sticky-js";


class ScrollReveal {
  constructor(options){
    this.options = options;
  }

  reveal(el, options, duration){
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire( el, function(){
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options,args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
        });
      });

      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.c-block-top-works__slider').find('.c-block-top-works__slide').length < 3){
          $('.c-block-top-works__slider').toggleClass('owl-carousel');
          return false;
        }

        $('.c-block-top-works__slider').owlCarousel({
          margin: 36,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: 480,
          autoHeight: false,
          center: false,
          navText: ['', '<img src="/wp-content/themes/ksks-html/dist/assets/images/icon-slider-next.png" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              margin: 16
            },
            // breakpoint from 750 up
            750: {

            }
          }
        });
      });
    }
    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }
      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '8';

      sr.reveal(".c-main-visual", {
        duration: 1400,
        opacity: 1,
        //translateY: -baseDistance,
        delay: 900,
      }, 100);

      sr.reveal(".c-solution__wrap  > *",{
        scale: [0.9, 1],
        opacity: 1,
        duration: 600,
        delay: anime.stagger(100),
        translateX: [-baseDistance,0],
        easing: baseEasing
      });
      domEach(".c-card-sm__block", function(key, item){

        sr.reveal(item,{
          scale: {
            value: [0.9,1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100*key,
          translateY: [-baseDistance,0],
          easing: baseEasing
        } );
      });
    }



    // slick
    function slickSlider() {

      if ($('.js-gallery-slider').length <0 ){
        return false;
      }

      if ($('.c-gallery-slider__thumbnail .c-gallery-slider__thumbnail-image').length < 2) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-none");
      }

      // 上段
      $('.c-gallery-slider__main').slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/ksks-html/dist/assets/images/icon-arrow-left.png" /></div>',
        nextArrow: '<div class="slick-next"><img src="/wp-content/themes/ksks-html/dist/assets/images/icon-arrow-next.png" /></div>',
        asNavFor: '.c-gallery-slider__thumbnail',
        autoplaySpeed: 2500,
        // centerPadding: '23.28%',
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1
          }
        }]
      });

      // 下段
      $('.c-gallery-slider__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.c-gallery-slider__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 4
          }
        }]
      });
    }

    // ループスライダー
    function infiniteSlider() {
      const optionInfinite = {
        infinite: true,
        arrows: false,
        swipe: false,
        dots: false,
        variableWidth: true,  // スライド幅の自動計算を無効
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        pauseOnFocus: false,
        pauseOnHover: false
      }
      const slickInfinite = $('.js-infinite-slider');
      if (slickInfinite) $(slickInfinite).slick(optionInfinite);
    }

    function ggFixedHeader() {


      if( window.innerWidth <= 950 ) {
        return;
      }

      const header = document.querySelector(".gg-fixed-header");

      if (!header) return;

      window.addEventListener("scroll",function(){

        if(window.pageYOffset==0 || window.pageYOffset<70){
          header.classList.remove("is-scrolled");
        } else {
          header.classList.add("is-scrolled");
        }
      });
     }

    function scrollNav() {
      if($(window).innerWidth() < 950) {
        return;
      }

      const boxes = document.querySelectorAll(".c-block-product-features__block");
      const nav = document.querySelectorAll(".c-block-sidebar");

      const nodes = Array.prototype.slice.call(boxes, 0);

      if (!nav.length) return;

      const options = {
        root: null, // 今回はビューポートをルート要素とする
        rootMargin: "-50% 0px", // ビューポートの中心を判定基準にする
        threshold: 0 // 閾値は0
      };
      const observer = new IntersectionObserver(doWhenIntersect, options);
// それぞれのboxを監視する
      nodes.forEach(box => {
        observer.observe(box);
      });

      function doWhenIntersect(entries) {
        // 交差検知をしたもののなかで、isIntersectingがtrueのDOMを色を変える関数に渡す
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            activateIndex(entry.target);
          }
        });
      }

      function activateIndex(element) {
        // すでにアクティブになっている目次を選択
        const currentActiveIndex = document.querySelector(".l-wrapper").querySelectorAll(".is-active");
        // すでにアクティブになっているものが0個の時（=null）以外は、activeクラスを除去
        const currentActiveNodes = Array.prototype.slice.call(currentActiveIndex, 0);

        if (currentActiveNodes.length) {
          currentActiveNodes.forEach(index => {

            index.classList.remove("is-active");
          })
        }

        // 引数で渡されたDOMが飛び先のaタグを選択し、activeクラスを付与
        const newActiveIndex = document.querySelectorAll(`a[href='#${element.id}']`);
        const activeNodes = Array.prototype.slice.call(newActiveIndex, 0);

        activeNodes.forEach(index => {
          index.classList.add("is-active");
        })
      }
    }

    function stickyNav() {
      var win = $(window).innerWidth();
      if (win > 950) {
        if ($(".c-block-sidebar").length > 0 && !$(".c-block-sidebar").hasClass("is-sticky-none")) {
          var sticky = new Sticky('.c-block-sidebar');
        }
      }
    }

    function infiniteSlider() {

      const slider = $(".c-block-infinite-slider__slide");

      if (!slider) return false;

      $(slider).slick({
        autoplay: true, //自動でスクロール
        autoplaySpeed: 0, //自動再生のスライド切り替えまでの時間を設定
        speed: 10000, //スライドが流れる速度を設定
        cssEase: "linear", //スライドの流れ方を等速に設定
        slidesToShow: 1, //表示するスライドの数
        centerMode: true,
        variableWidth: true,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false, // 操作による切り替えはさせない
        arrows: false, //矢印非表示
      });
    }

    // function filterCards() {
    //   const btns = document.querySelectorAll(".c-box-links-filter__item a");
    //   const cards = document.querySelectorAll(".c-block-experience__block");
    //   if (!btns.length || !cards.length) return;
    //
    //   const btnsNodes = Array.prototype.slice.call(btns, 0);
    //   const cardsNodes = Array.prototype.slice.call(cards, 0);
    //
    //
    //   for (const btn of btnsNodes) {
    //     btn.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       const targetBtn = e.target;
    //       const filterBy = e.target.dataset.filter;
    //
    //       const activeItem = countActiveItem();
    //
    //       if (!activeItem) {
    //         targetBtn.classList.toggle("is-active");
    //         filterBykeyword(filterBy, cardsNodes);
    //         return;
    //       }
    //
    //       const currentFilter =  activeItem.dataset.filter;
    //
    //       if (currentFilter !== filterBy) {
    //         removeActiveClass(btnsNodes);
    //         targetBtn.classList.toggle("is-active");
    //         filterBykeyword(filterBy, cardsNodes);
    //         return;
    //       }
    //
    //
    //       targetBtn.classList.toggle("is-active");
    //       filterBykeyword(true, cardsNodes);
    //
    //     })
    //   }
    //
    //
    //   const removeActiveClass = (btns) => {
    //     for (const btn of btns) {
    //       if (btn.classList.contains("is-active")) {
    //         btn.classList.remove("is-active");
    //       }
    //     }
    //   }
    //
    //   const countActiveItem = () => {
    //     const activeBtn = document.querySelector(".c-box-links-filter__item a.is-active");
    //     return activeBtn ? activeBtn : false;
    //   }
    //
    //
    //   const filterBykeyword = (keyword, cards) => {
    //
    //     const cardWrapper = document.querySelector(".c-block-experience__blocks");
    //
    //     cardWrapper.innerHTML = ``;
    //
    //     for (const card of cards) {
    //       if (card.dataset.filter === keyword) {
    //         const blockEl = document.createElement('a');
    //         blockEl.classList.add("c-block-experience__block");
    //         blockEl.href = card.href;
    //
    //         const imageEl = document.createElement("div");
    //         imageEl.classList.add("c-block-experience__image");
    //
    //         const bgEl = document.createElement("div");
    //         bgEl.classList.add("is-bg");
    //         const bgStyle = card.querySelector(".is-bg").style.backgroundImage;
    //         bgEl.style.backgroundImage = bgStyle;
    //
    //         const contentEl = document.createElement("div");
    //         contentEl.classList.add("c-block-experience__content");
    //
    //
    //         const titleEl = document.createElement("div");
    //         const title = card.querySelector(".c-block-experience__title").textContent;
    //         titleEl.classList.add("c-block-experience__title");
    //         titleEl.innerText = title;
    //
    //
    //         const optionsEl = document.createElement("div");
    //         optionsEl.classList.add("c-block-experience__options");
    //
    //
    //         const labelEl = document.createElement("div");
    //         labelEl.classList.add("c-block-experience__label");
    //         const label = card.querySelector(".c-block-experience__label").textContent;
    //         labelEl.innerText = label;
    //
    //
    //         const tagEl = document.createElement("div");
    //         tagEl.classList.add("c-block-experience__tag");
    //         const tag = card.querySelector(".c-block-experience__tag").textContent;
    //         tagEl.innerText = tag;
    //
    //         optionsEl.appendChild(labelEl);
    //         optionsEl.appendChild(tagEl);
    //
    //         imageEl.appendChild(bgEl);
    //         contentEl.appendChild(titleEl);
    //         contentEl.appendChild(optionsEl);
    //         blockEl.appendChild(imageEl);
    //         blockEl.appendChild(contentEl);
    //
    //         cardWrapper.appendChild(blockEl)
    //       }
    //     }
    //   }
    // }

    $(function () {
      menuSlide();
      owlCarousel();
      reveal();
      slickSlider();
      ggFixedHeader();
      scrollNav();
      stickyNav();
      infiniteSlider();

    });
  }
}

window.GApp = new App();
